import React from "react";
import ImgSrc from "../../../Assets/common/error-alert-button-symbol.png";
import { useLocation } from "react-router-dom";
import Profile from "../../../pages/profile";
import Upgrade from "../../../pages/upgrade";

export default function AccountBlockDialog() {
  const { pathname } = useLocation();

  const handleMailClick = () => {
    const subject = encodeURIComponent("Account Access Issue - Support Needed");
    const body = encodeURIComponent(
      `It might be due to admin restrictions, limited access based on your account type, or a temporary block`
    );

    window.location.href = `mailto:hello@rankspro.io?subject=${subject}&body=${body}`;
  };

  if (pathname === "/account") return <Profile />;
  if (pathname === "/upgrade") return <Upgrade />;
  return (
    <React.Fragment>
      <div
        className="pllogin-div"
        style={{
          height: "90vh",
          maxWidth: "700px",
          margin: "auto",
        }}
      >
        <div className="add-new-project flex-column align-items-center">
          <div className="project-img" style={{ minHeight: "160px" }}>
            <img src={ImgSrc} alt="" style={{ maxWidth: "150px" }} />
          </div>
          <div className="pl-con flex-column p-0">
            <h2 className="heading-large w-75">
              You cannot access this right now
            </h2>
            <p className="heading-medium">
              It might be due to admin restrictions, limited access based on
              your account type, or a temporary block. If the issue persists,
              contact support or your admin for help unlocking access.
            </p>
            <button className="upgrade-plan-btn" onClick={handleMailClick}>
              Contact Support
              <svg
                className="ms-2"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#FEFDFF" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.135 7.52148C10.8477 7.25108 10.8341 6.79903 11.1045 6.51179C11.3749 6.22455 11.8269 6.21091 12.1142 6.48131L17.2822 11.3465C17.5346 11.4567 17.7109 11.7084 17.7109 12.0014C17.7109 12.294 17.5351 12.5454 17.2833 12.6559L12.1142 17.522C11.8269 17.7924 11.3749 17.7788 11.1045 17.4915C10.8341 17.2043 10.8477 16.7523 11.135 16.4819L15.1356 12.7157H6.99611C6.60162 12.7157 6.28182 12.3959 6.28182 12.0014C6.28182 11.6069 6.60162 11.2871 6.99611 11.2871H15.135L11.135 7.52148Z"
                  fill="#E95655"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
